import ActiveCampaignClient from '../activeCampaign/ActiveCampaignClient';
import AuthClient from '../auth/AuthClient';
import ConversationsClient from '../travel/ConversationsClient';
import CountrySettingsClient from '../travel/CountrySettingsClient';
import DefaultApiClient from './DefaultApiClient';
import DestinationsClient from '../travel/DestinationsClient';
import DocumentsClient from '../documents/DocumentsClient';
import HubspotClient from '../hubspot/HubspotClient';
import MessagesClient from '../messages/MessagesClient';
import NotificationsClient from '../travel/NotificationsClient';
import PartnersClient from '../travel/PartnersClient';
import PeopleClient from '../people/PeopleClient';
import PhotosClient from '../photos/PhotoServiceClient';
import ReviewsClient from '../travel/ReviewsClient';
import SalesRecordingsClient from '../travel/SalesRecordingsClient';
import ScreeningCriteriaClient from '../travel/ScreeningCriteriaClient';
import ScreeningResultsClient from '../travel/ScreeningResultsClient';
import StandardsClient from '../standards/StandardsClient';
import TemplatesClient from '../templates/TemplatesClient';
import TripMatchesClient from '../travel/TripMatchesClient';
import TripRequestsClient from '../travel/TripRequestsClient';
export default class ZApiClient {
    constructor(env, token, axiosConfig, useLocalTApi, useLocalPhotosService) {
        this.instance = new DefaultApiClient(env, token, axiosConfig, useLocalTApi, useLocalPhotosService);
        this.activeCampaignClient = new ActiveCampaignClient(this.instance);
        this.authClient = new AuthClient(this.instance);
        this.conversationsClient = new ConversationsClient(this.instance);
        this.countrySettingsClient = new CountrySettingsClient(this.instance);
        this.destinationsClient = new DestinationsClient(this.instance);
        this.documentsClient = new DocumentsClient(this.instance);
        this.hubspotClient = new HubspotClient(this.instance);
        this.messagesClient = new MessagesClient(this.instance);
        this.notificationsClient = new NotificationsClient(this.instance);
        this.partnersClient = new PartnersClient(this.instance);
        this.peopleClient = new PeopleClient(this.instance);
        this.photosClient = new PhotosClient(this.instance);
        this.reviewsClient = new ReviewsClient(this.instance);
        this.salesRecordingsClient = new SalesRecordingsClient(this.instance);
        this.screeningCriteriaClient = new ScreeningCriteriaClient(this.instance);
        this.screeningResultsClient = new ScreeningResultsClient(this.instance);
        this.standardsClient = new StandardsClient(this.instance);
        this.templatesClient = new TemplatesClient(this.instance);
        this.tripMatchesClient = new TripMatchesClient(this.instance);
        this.tripRequestsClient = new TripRequestsClient(this.instance);
    }
}
